import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { addLocaleToHref } from 'lib/utils/helpers';
import { formatPriceByStoreLocale } from 'lib/shopify';
import styles from './productVariations.module.scss';
import SiteLink from '../../../shared/sitelink';

const ProductVariations = ({ locale, productData, resources, localeHasWebshop }) => {
  const router = useRouter();

  const { shopifyData, slug, size, productVariations } = productData;

  const { chooseVariant } = resources.productpage;

  const allSortedProductVariations = useMemo(
    () =>
      [
        productVariations.length
          ? {
              sizeInteger: parseInt(size.replace('ml', ''), 10),
              size,
              price: formatPriceByStoreLocale({ locale, price: shopifyData.productPrice }),
              isCurrentProduct: true,
              slug,
            }
          : null,
        ...productVariations.map(v => {
          const sizeInteger = parseInt(v.size.replace('ml', ''), 10);
          const price = formatPriceByStoreLocale({
            locale,
            price: v?.shopifyData?.variants?.[0].price,
          });
          return {
            ...v, // size and slug
            sizeInteger,
            price,
          };
        }),
      ]
        .filter(v => v?.isCurrentProduct || v?.shopifyData?.variants?.[0]?.price)
        .sort((a, b) => a.sizeInteger - b.sizeInteger),
    [productVariations, shopifyData, locale, slug, size]
  );

  return shopifyData?.productPrice && allSortedProductVariations?.length > 1 ? (
    <>
      <h3 className={styles.productVariationsTitle}>{chooseVariant.text}</h3>
      <div className={styles.productVariations}>
        {allSortedProductVariations.map(variant => {
          if (variant.isCurrentProduct) {
            return (
              <p key={`${variant.slug}-${Math.random()}`} className={styles.currentProductVariant}>
                <span className={styles.variantSize}>{variant.size}</span>
                {localeHasWebshop && <span className={styles.variantPrice}>{variant.price}</span>}
              </p>
            );
          }
          return (
            <SiteLink
              key={`${variant.slug}-${Math.random()}`}
              className={styles.variantLink}
              href={addLocaleToHref(variant.slug, locale, router)}
            >
              <span className={styles.variantSize}>{variant.size}</span>
              {localeHasWebshop && <span className={styles.variantPrice}>{variant.price}</span>}
            </SiteLink>
          );
        })}
      </div>
    </>
  ) : null;
};

export default ProductVariations;
